import type { ComponentType, ReactNode } from "react";

/**
 * Optional wrapper rendered inside {@link AtomStoreProvider} once the atom store
 * and API client contexts are available (e.g. Better Auth UI provider shell).
 */
export type FrameworkInnerWrapperProps = {
  children: ReactNode;
};

let innerWrapper: ComponentType<FrameworkInnerWrapperProps> | null = null;

export function registerFrameworkInnerWrapper(
  wrapper: ComponentType<FrameworkInnerWrapperProps>,
): void {
  innerWrapper = wrapper;
}

export function getFrameworkInnerWrapper(): ComponentType<FrameworkInnerWrapperProps> | null {
  return innerWrapper;
}
